import LoadingState from '@/api/LoadingState';

const state = {
  loadingState: LoadingState.INITIAL,
  projects: [],
  current: {}
}

export default state
